/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferralUser
 */
export interface ReferralUser {
    /**
     * 
     * @type {string}
     * @memberof ReferralUser
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralUser
     */
    readonly full_name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReferralUser
     */
    readonly is_pro: boolean;
}

/**
 * Check if a given object implements the ReferralUser interface.
 */
export function instanceOfReferralUser(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "full_name" in value;
    isInstance = isInstance && "is_pro" in value;

    return isInstance;
}

export function ReferralUserFromJSON(json: any): ReferralUser {
    return ReferralUserFromJSONTyped(json, false);
}

export function ReferralUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'full_name': json['full_name'],
        'is_pro': json['is_pro'],
    };
}

export function ReferralUserToJSON(value?: ReferralUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

